import { registerQuery } from 'data-fetching-client';
import { ecosystemAppClient } from '../../common/clients/ecosystemClient';
export const GET_ASSET_INSTALLABILITY = registerQuery({
  fieldName: 'assetInstallability',
  args: ['offeringId'],
  fetcher: ({
    offeringId
  }) => {
    return ecosystemAppClient.get(`assets/${offeringId}/installability`);
  }
});